"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessToken2 = void 0;
const Request_1 = require("./Request");
/**
 * Retrieve access token from accounts API
 */
class AccessToken2 {
    constructor(options) {
        this.tokenRequest = options;
        this.request = new Request_1.Request({
            baseUrl: options.endpoint,
            axios: {
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers,
                },
            },
        });
    }
    async getToken() {
        if (this.token && Date.now() < this.expiresAt) {
            return this.token;
        }
        const response = await this.request.post('/oauth/token', this.tokenRequest);
        this.token = response.data.accessToken;
        this.expiresAt = response.data.expiresAt * 1000;
        return response.data.accessToken;
    }
}
exports.AccessToken2 = AccessToken2;
//# sourceMappingURL=AccessToken2.js.map